import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  colors: {
    brand: {
      bgleft: "#2b6777",
      bgright: "#c8d8e4",
      bg: "#ffffff",
      btn1: "#f2f2f2",
      btn2: "#52ab98",
    },
  },
});

export default theme;
